import { startCustomDriver, Config } from '@/components/float-btn/recorder/guide/customDriver';
import { useRootInstance } from 'common-module/src/util/useRootInstance';
import { waitGetAny } from '@zk/framework-vue';

let currentConfig: any;
let currentGuideIndex: number = 0;
let guide: any;
let newGuideKey: string;
let newGuideName: string;

export const STEP_CONFIG: Config[] = [
  {
    selector: '.zk-ai-comment-summary-icon',
    scopeName: 'ai-summary-icon',
    clickToNext: true,
    popover: {
      title: 't(userGuide.aiCommentSummary.title)',
      description: 't(userGuide.aiCommentSummary.desc1)',
      position: 'bottom-right'
    },
    addScopeCss: (name: string) => {
      return `
      .${name} .el-drawer__wrapper {
        position: absolute;
        z-index: auto !important;
      }
      .${name} .driver-highlighted-element {
        //background-color: #fff !important;
      }
      `;
    }
  },
  {
    selector: '.zk-ai-summarize-popper',
    getElement: async() => {
      return await waitGetAny(() => {
        const loadingFinish = document.querySelector('.zk-ai-summarize-popper__main') as HTMLElement;
        return loadingFinish ? document.querySelector('.zk-ai-summarize-popper') : null;
      }, { interval: 50, timeout: 10000 });
    },
    scopeName: 'generate-subtask-item',
    clickToClose: true,
    popover: {
      title: 't(userGuide.aiCommentSummary.title)',
      description: 't(userGuide.aiCommentSummary.desc2)',
      position: 'top-right'
    },
    addScopeCss: (name: string) => {
      return `
      .${name} .el-drawer__wrapper {
        position: absolute;
        z-index: auto !important;
      }
      .${name} .driver-highlighted-element {
        background-color: #fff;
      }
      .${name} .driver-highlighted-element .zk-issue-detail-subtask-summary__edit-icon{
        display: inline-flex;
      }
      `;
    }
  }
];

async function awaitOpenIssueDetail(instance: any, issueData: {id: number, [key:string]: any}) {
  return new Promise(
    (resolve, reject) => {
      instance.eventBus.$emit('issue:edit', issueData || {});
      instance.eventBus.$on('issue:closed', reject);
      waitGetAny(() => {
        return document.querySelector('.zk-issue-detail-field-description');
      }, { interval: 50, timeout: 10000 }).then(resolve).catch(reject).finally(
        () => {
          instance.eventBus.$off('issue:closed', reject);
        }
      );
    }
  );
}

export async function startAiCommentSummaryGuide(guideKey: string, guideName: string, issueData: {id: number}) {
  if (!guideKey) {
    return;
  }
  const instance = useRootInstance();
  if (!issueData?.id) {
    instance.$message.warning(instance.$t('userGuide.aiCommentSummary.deleteTip'));
    return;
  }
  // 打开详情
  await awaitOpenIssueDetail(instance, { ...issueData, activeTab: 'comment' });
  newGuideKey = guideKey;
  newGuideName = guideName;
  currentConfig = STEP_CONFIG;
  startGuide(0);
}


const toNext = () => {
  if (currentGuideIndex === currentConfig.length - 1) {
    finishNewGuide();
    onClose();
    return;
  }
  currentGuideIndex++;
  startGuide(currentGuideIndex);
};

async function finishNewGuide() {
  const instance = useRootInstance();
  instance.eventBus.$emit('finish-guide-task', newGuideKey);
}

function getCurrentStepConfig (index: number) {
  const stepConfig: any = currentConfig[index];
  const total = Object.keys(STEP_CONFIG).length;
  const progress = `${index + 1} / ${total}`;
  stepConfig.progress = progress;
  return stepConfig;
}


function onIssueClose() {
  guide?.stop();
}

function initEventListener() {
  const instance = useRootInstance();
  instance.eventBus.$on('issue:closed', onIssueClose);
}

function offEventListener() {
  const instance = useRootInstance();
  instance.eventBus.$off('issue:closed', onIssueClose);
}

function clear() {
  currentGuideIndex = 0;
  guide = null;
  newGuideKey = '';
  newGuideName = '';
  offEventListener();
}

const onClose = () => {
  if (!guide) {
    return;
  }
  const instance = useRootInstance();
  const isLast = currentGuideIndex === currentConfig.length - 1;
  instance.$track.send('Guide_DoneTask', { task_name: newGuideName, finish: isLast }, true);
  clear();
};

async function startGuide(index: number) {
  currentGuideIndex = index;
  const stepConfig = getCurrentStepConfig(index);
  if (!stepConfig) {
    return;
  }
  const instance = useRootInstance();
  guide = await startCustomDriver(
    {
      config: stepConfig,
      onNext: toNext,
      onClose: onClose
    },
    instance
  );
  offEventListener();
  initEventListener();
}
